import { Badge, Box, Flex, Heading, HStack, Text } from "@chakra-ui/react"
import type { ReactNode } from "react"

type WmsPageHeaderProps = {
  actions?: ReactNode
  badge?: ReactNode
  description: string
  gradient: string
  title: string
}

export function WmsPageHeader({
  actions,
  badge,
  description,
  gradient,
  title,
}: WmsPageHeaderProps) {
  return (
    <Box
      bgGradient={gradient}
      color="white"
      borderRadius="2xl"
      px={{ base: 5, md: 8 }}
      py={{ base: 4, md: 5 }}
      boxShadow="lg"
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        gap={4}
      >
        <Box>
          <Heading size="lg">{title}</Heading>
          <Text mt={1} opacity={0.95}>
            {description}
          </Text>
        </Box>
        <HStack spacing={3} flexWrap="wrap">
          {actions}
          {typeof badge === "string" ? (
            <Badge
              bg="whiteAlpha.300"
              color="white"
              borderRadius="full"
              px={3}
              py={1}
            >
              {badge}
            </Badge>
          ) : (
            badge
          )}
        </HStack>
      </Flex>
    </Box>
  )
}
